import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '@tanstack/react-router';
import { ROUTES } from '@/lib/constants';
import { useStudentTestsUrl } from '../hooks/useStudentTestsUrl';
/**
 * Sidebar "Tests" entry. When the backend has built the Solutest URL (student has
 * DNI + phone), it renders a plain external link that opens in a new tab — the
 * behaviour that works reliably. Otherwise it links to the /alumno/tests page,
 * which prompts the student to add a phone.
 */
export function TestsSidebarLink({ className, style, hover, title, children }) {
    const { data } = useStudentTestsUrl();
    const url = data?.url;
    if (url) {
        return (_jsx("a", { href: url, target: "_blank", rel: "noopener noreferrer", className: className, style: style, title: title, ...hover, children: children }));
    }
    return (_jsx(Link, { to: ROUTES.STUDENT_TESTS, className: className, style: style, title: title, ...hover, children: children }));
}
//# sourceMappingURL=TestsSidebarLink.js.map